//操作类型
const opType = new Map([
  [0, '系统登录'],
  [1, '访问页面'],
  [2, '管理操作'],
  [3, '系统安全'],
]);
//审计级别
const audioLevel = new Map([
  [1, '一般'],
  [2, '提示'],
  [3, '警告'],
  [4, '严重'],
]);

// 会员类型
const vipType = [{
  value: 0,
  label: "员工",
}, {
  value: 1,
  label: "个人",
}, {
  value: 2,
  label: "合作商",
}]

const payType = [{
  value: "1",
  label: "现金",
}, {
  value: "2",
  label: "微信支付",
}, {
  value: "3",
  label: "挂账",
}, {
  value: "4",
  label: "预付卡",
}, {
  value: "5",
  label: "刷卡支付",
}, {
  value: "6",
  label: "银联支付",
}, {
  value: "7",
  label: "支付宝",
}, {
  value: "8",
  label: "记账",
}, {
  value: "19",
  label: "其它",
}]

// 会员状态
const vipStatus = [{
  value: 0,
  label: "正常",
}, {
  value: 1,
  label: "锁定",
}]

//预付卡状态
const prePayCardStatus = [{
  value: 0,
  label: "正常",
}, {
  value: 1,
  label: "冻结",
}, {
  value: 2,
  label: "失效",
}, {
  value: 3,
  label: "退卡",
}]

// 还款方式
const repayType = [{
  value: 1,
  label: "现金",
}, {
  value: 2,
  label: "微信",
}, {
  value: 4,
  label: "预付卡",
}, {
  value: 9,
  label: "退费",
}]

//还款状态
const repayStatus = [{
  value: 0,
  label: "未还款",
}, {
  value: 1,
  label: "已还款",
}]

//库存用途
const wareHouseTarget = [{
    value: 1,
    label: "车辆附加"
  },
  {
    value: 2,
    label: "日常办公"
  },
]
//库存申请类型
const wareHouseType = [{
    value: 1,
    label: "入库"
  },
  {
    value: 2,
    label: "出库"
  },
]
const wareHouseStatus = [{
    value: 0,
    label: "申请中"
  },
  {
    value: 1,
    label: "已审核"
  },
  {
    value: 2,
    label: "不通过"
  },
  {
    value: 3,
    label: "已办结"
  },
  {
    value: 4,
    label: "已取消"
  },
]

const equipMaintainType = [{
    value: 1,
    label: "维修"
  },
  {
    value: 2,
    label: "保养"
  },
]


function getHeight({
  hasCommand = false,
  line = 1,
  adjust = 0,
} = {}) {


  let top = 60;
  let bottom = 60;
  let lmume = hasCommand ? 46 : 10;
  let searchbox = 46 * line + 48;

  return window.innerHeight - top - bottom - lmume - searchbox - adjust - 80;

  // let lmume = hasCommand ? 46 : 10;
  // let searchbox = 36 * line + 74;

  // return window.innerHeight - top - bottom - lmume - searchbox - adjust - 80;
}

export default {
  opType,
  audioLevel,
  vipType,
  vipStatus,
  prePayCardStatus,
  repayType,
  payType,
  repayStatus,
  wareHouseTarget,
  wareHouseType,
  wareHouseStatus,
  equipMaintainType,
  getHeight
}



// WEBPACK FOOTER //
// ./src/js/global_variables.js